import BaseService from "./base.service";

class ContractAgreementService extends BaseService {
  get entity() {
    return "contract-agreement";
  }
  acceptEnrollmentContract(enrollmentId) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true })
        .post(`${this.entity}/${enrollmentId}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          const message = error.response.data
            ? error.response.data.error
            : error.response.statusText;
          reject(this.errorWrapper(error, message));
        });
    });
  }
}
export default new ContractAgreementService();
